module.exports = __webpack_public_path__ + "static/Contact_and_first_proposal-bf8375b0c701f11a827c6456af68b2dc.png";